<template>
  <div class="photo-picker">
    <!-- 顶部操作栏 -->
    <div class="action-bar">
      <van-button type="primary" size="small" style="margin-right: 20px;" @click="createRes">创建资源包</van-button>
      <van-button type="danger" v-if="showResView" size="small" @click="handleClearAll">一键清除</van-button>
    </div>
    <!-- 图片预览网格 -->
    <div v-if="showResView" class="preview-grid">
      <div
          v-for="(item, index) in resList" :key="index"
          class="preview-item"
          @touchstart="handleTouchStart(index)"
          @touchend="handleTouchEnd"
          @click="handleSelect(index)"
      >
        <van-image
            fit="cover"
            src="https://qiniu.dljok.com/static/wxapp/icon/icon_rar.png"
            :class="{ 'selected': item.selected }"
        />
        <span class="name">{{ item.name }}</span>
        <div class="number">文件数：{{ item.resourceList.length }}</div>
        <div v-show="item.selected" class="checkmark">
          <van-icon name="success" size="20"/>
        </div>
        <!-- 上传按钮 - 已调整样式 -->
        <van-button
            class="upload-btn"
            type="primary"
            size="small"
            @click.stop="onOpenUploadRes(item.id)"
        >
          上传/查看
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import {Uploader, Button, Image, Icon, Toast, Dialog} from 'vant';
import {mapGetters} from "vuex";

export default {
  components: {
    [Uploader.name]: Uploader,
    [Button.name]: Button,
    [Image.name]: Image,
    [Icon.name]: Icon
  },
  data() {
    return {
      longPressTimer: null,
      currentIndex: -1,
      page: 1,
      size: 24,
      resList: [],
      currentUploadIndex: -1
    };
  },
  computed: {
    showResView() {
      return this.resList.length > 0;
    },
    ...mapGetters(["userInfo"]),
  },
  created() {
    this.loadDataList();
  },
  mounted() {
    this.$Bus.$on("triggerRefreshResData", (val) => {
      this.loadDataList();
    });
  },
  beforeDestroy() {
    this.$Bus.$off("triggerRefreshResData");
  },
  methods: {
    createRes() {
      this.$emit('onOpenAddRes');
    },
    handleTouchStart(index) {
      this.currentIndex = index;
      this.longPressTimer = setTimeout(() => {
        this.handleDelete(index);
      }, 1000);
    },
    handleTouchEnd() {
      clearTimeout(this.longPressTimer);
    },
    handleSelect(index) {
      this.resList[index].selected = !this.resList[index].selected;
      this.$forceUpdate();
      const selectedList = this.resList.filter(item => item.selected);
      this.$emit('select-res-success', selectedList);
    },
    handleClearAll() {
      Dialog.confirm({
        title: '清除确认',
        message: '确定要清除所有资源包吗？',
      }).then(() => {
        this.resList = [];
        this.$http.delete(`/api/dlrUserResourcePackage/clear`).then(() => {
          Toast.success('已清除所有资源包');
        }).catch(() => {
          Toast.fail('清除失败！');
        });
      }).catch(() => {
        console.log('取消清除！');
      });
    },
    loadDataList() {
      Toast.loading('加载中...');
      this.$http.get('/api/dlrUserResourcePackage/queryPageList', {
        params: {
          page: this.page,
          size: this.size
        }
      }).then(res => {
        this.resList = res.data.content.map(item => ({
          ...item,
          selected: false
        }));
      }).finally(() => {
        Toast.clear(true);
      });
    },
    handleDelete(index) {
      Dialog.confirm({
        title: '删除确认',
        message: '确定要删除此资源包吗？',
      }).then(() => {
        const id = this.resList[index].id;
        this.$http.delete(`/api/dlrUserResourcePackage/delete?id=${id}`).then(() => {
          this.resList.splice(index, 1);
          Toast.success('删除成功');
        }).catch(() => {
          Toast.fail('删除失败');
        });
      }).catch(() => {
      });
    },
    onOpenUploadRes(packageId) {
      this.$Bus.$emit("triggerOpenUpRes", packageId);
    }
  }
};
</script>

<style lang="less" scoped>
// 定义变量
@primary-color: #1989fa;
@danger-color: #ee0a24;
@success-color: #07c160;
@border-radius: 12px;
@box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
@transition: all 0.3s ease;

.photo-picker {
  padding: 16px;
  //border: 1px solid #FF6B95;
  height: 100%;
  overflow-y: auto;
}

.action-bar {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: #FFF;
  padding: 10px 20px;
  border-radius: @border-radius;
  min-height: 60px;
  margin-bottom: 16px;

  .van-button {
    &--primary {
      background-color: @primary-color;
      border-color: @primary-color;
    }

    &--danger {
      background-color: @danger-color;
      border-color: @danger-color;
    }
  }
}

.preview-grid {
  display: grid;
  /* 定义 5 列，每列宽度相等，自动填充可用空间 */
  //grid-template-columns: repeat(5, 1fr);
  grid-template-columns: repeat(auto-fill, minmax(70px, 1fr));  // 自动填充 + 最小宽度70px
  gap: 8px;  // 10px → 8px
  width: 100%;
  height: 300px;
  overflow-y: auto;
  padding: 20px 0px;
  /* 可选：添加一些间距 */
  //gap: 10px;
  .preview-item {
    //padding: 10px;
    background-color: #FFF;
    position: relative;
    border: 1px solid #fff;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 10px;

    .van-image {
      width: 90px;
      height: 90px;
      //border: 1px solid #FF6B95;
    }

    .name {
      font-size: 12px;
      font-weight: 600;
      color: #FFF;
      text-align: center;
      width: 100%;
      background-color: fade(@success-color, 80%);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      //border: 1px solid #FF6B95;
    }

    .number {
      color: #000;
      //font-size: 18px;
      font-size: 12px;
      font-weight: 600;
      background-color: #FFF;
      //padding:5px 10px;
      //border: 1px dashed #888888;
      width: 100%;
      text-align: center;
    }

    .checkmark {
      position: absolute;
      top: 6px;
      right: 6px;
      background: @success-color;
      border-radius: 50%;
      padding: 4px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

      .van-icon {
        color: white;
        display: block;
      }
    }

    .upload-btn {
      width: 100%;
      height: 28px;
      font-size: 12px;
      font-weight: 500;
      border-radius: 8px;
      //margin-top: 8px;
      transition: all 0.2s ease;

      &:hover {
        opacity: 0.9;
        transform: translateY(-2px);
      }

      &:active {
        transform: translateY(0);
      }

      .van-button__content {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
